import { gql } from '@edreamsodigeo/frontend-api-client';

export const api = gql`
  fragment AirlineTrackingPositionInfo on TrackingPosition {
    crossFaring
    position
    itineraryId
  }
`;
